real.notification = (function ($, real) {
    'use strict';

    let notificationBar = null;
    let notificationBarContent = null;

    const appendNotificationBar = function () {
        const $visibleModal = $('.modal:visible');
        if (
            $visibleModal.length > 0 &&
            $visibleModal.find('.modal-body').length > 0 &&
            !$visibleModal[0].hasAttribute('closing') &&
            $visibleModal[0].hasAttribute('open')
        ) {
            // There is an open modal, it has body, and it is not closing.
            $visibleModal.find('.modal-body').first().before(notificationBar);
        } else if ($('#live-popout-layout').length > 0) {
            // Append before the live layout.
            $('#live-popout-layout').before(notificationBar);
        } else if ($('#notifications').length > 0) {
            // Append into the notifications area.
            $('#notifications').append(notificationBar);
        } else {
            // Append to the top element.
            real.dom.$top.append(notificationBar);
        }
    };

    return {
        show: function (content, type, showCloseBtn) {
            // Allow href and target="_blank" for links when sanitizing. Allow data: and blob: URIs for links.
            const options = {
                ADD_ATTR: ['href', 'target'],
                ADD_DATA_URI_TAGS: ['a'],
                ADD_URI_SAFE_ATTR: ['href']
            };
            DOMPurify.addHook('uponSanitizeAttribute', (node, data) => {
                if (data.attrName === 'href') {
                    if (data.attrValue.startsWith('blob:')) {
                        data.keepAttr = true;
                    }
                }
            });
            content = DOMPurify.sanitize(content, options);

            if (notificationBar === null) {
                const notificationBarHtml = `
                    <div id="real-notification-bar" class="blur-when-modal-open">
                        <div id="real-notification-bar-content" role="alert"></div>
                        <button id="notification-bar-close-btn"
                                aria-label="Close notification bar"
                                class="d-flex justify-content-center align-items-center">
                            <i class="fa-light fa-xmark"></i>
                        </button>
                    </div>`
                ;

                real.dom.$top.append(notificationBarHtml);

                notificationBar = $('#real-notification-bar');
                notificationBarContent = notificationBar.find('#real-notification-bar-content');

                notificationBar.find('#notification-bar-close-btn').on('click', real.notification.hide);
            }

            appendNotificationBar();
            notificationBar.show();

            if (notificationBarContent.text().trim() === '') {
                notificationBarContent.css('min-height', 0);
            }
            let origHeight = notificationBar.height();
            if (notificationBarContent.height() === 0) {
                origHeight = 0;
            }

            notificationBar.removeClass('light success warning danger');
            if (!type) {
                type = 'light';
            }
            notificationBar.addClass(type);

            if (showCloseBtn === false) {
                notificationBar.addClass('hide-close-btn');
            } else {
                notificationBar.removeClass('hide-close-btn');
            }

            notificationBarContent.findIncludingSelf('*').off().removeData();

            const origContent = notificationBarContent.html();
            notificationBarContent.html(content);

            // Remove CSS height from notification bar (if it's in the middle
            // of animation then animHeight would be calculated wrong).
            notificationBar.css({height: '', width: ''});
            const animHeight = notificationBar.height();
            const animWidth = notificationBar.width();
            notificationBarContent.html(origContent);
            notificationBar.height(origHeight);

            real.dom.$html.css('--notification-bar-height', animHeight + 'px');
            notificationBar.css({overflow: 'hidden', whiteSpace: 'nowrap'});
            notificationBar.velocity({
                height: animHeight,
                width: animWidth
            }, {
                duration: 'fast',
                begin: function () {
                    notificationBar.removeClass('has-timer-content');
                },
                complete: function () {
                    notificationBarContent.css('min-height', '');
                    notificationBar.css({height: '', width: '', overflow: '', whiteSpace: ''});
                }
            });

            notificationBarContent.velocity({
                opacity: 0
            }, {
                duration: 'fast',
                complete: function () {
                    notificationBarContent.html(content);
                    real.dom.$html.css('--notification-bar-height', notificationBar.outerHeight() + 'px');

                    notificationBar.trigger(real.notification.STARTING_TO_SHOW_NEW_CONTENT);

                    notificationBarContent.velocity({
                        opacity: 1
                    }, {
                        duration: 'fast',
                        complete: function () {
                            notificationBarContent.css('opacity', '');
                        }
                    });
                }
            });

            return notificationBar;
        },

        showOnNextPageLoad: function (content, type, showCloseBtn) {
            real.localStorage.set('show-notification', {
                content: content,
                type: type,
                showCloseButton: showCloseBtn
            });
        },

        hide: function () {
            if (notificationBar === null || notificationBar.is(':hidden')) {
                return;
            }

            notificationBar.trigger(real.notification.STARTING_TO_HIDE);

            real.dom.$html.css('--notification-bar-height', '');
            notificationBar.velocity('slideUp', {
                duration: 'fast',
                complete: function () {
                    notificationBarContent.html('');
                }
            });
        }
    }

})(jQuery, real);

real.notification.STARTING_TO_SHOW_NEW_CONTENT = 'real-notification-starting-to-show-new-content';
real.notification.STARTING_TO_HIDE = 'real-notification-starting-to-hide';

real.onTierReady(real.TIER_2, function () {
    const showNotification = real.localStorage.get('show-notification');
    if (showNotification !== null) {
        real.localStorage.remove('show-notification');
        real.notification.show(showNotification.content, showNotification.type, showNotification.showCloseButton);
    }
});
